import { createFileRoute } from '@tanstack/react-router'
import { JobInfo } from 'pages/jobInfo/JobInfo'
import { jobSearchParams } from 'routes/job/-searchParams'

const RouteComponent = () => {
  const { jobId, mode, orgId, siteId } = Route.useSearch()

  return <JobInfo jobId={jobId} mode={mode} orgId={orgId} siteId={siteId} />
}

export const Route = createFileRoute('/job/')({
  component: RouteComponent,
  staticData: {
    title: 'Job Details',
    layout: {
      enableScrolling: true,
    },
  },
  validateSearch: jobSearchParams,
})
